module.exports = __webpack_public_path__ + "img/star.3652ec97.svg";